export const EMAIL_INITIATION_METHODS = {
  AGENT_REPLY: 'AGENT_REPLY',
  OUTBOUND: 'OUTBOUND'
} as const;
